!function(root, app){
    //This runs on all event pages
    $('.event-navigation--select').on('change', function() {
        document.location = $(this).val();
    });

    var mathUtil = app.mathUtil;

    var isMobile, isTablet, isVideoPoppedOut, isVideoBound = false, isVideoPlaying = false, isLightboxOpen = false;
    var sgPlayer;
    var lucioVals;
    var lucioballTextHeight;
    //Store jquery selectors
    var $window = $(window);
    //var $animatedElements;

    //Trailer header elements
    var $sgIframe = $('[data-js="video-wrapper"]');
    var $videoClose = $('[data-video-close="true"]');
    var $videoCloseTop = $('[data-js="video-close-top"]');

    //Overview section elements
    var $sgOverview = $('[data-js="sg-overview"]');
    var $sgOverviewBackground = $('[data-js="sg-overview-background"]');
    var $sgOverviewLogo = $('[data-js="logo-container"]');
    var $sgOverviewContent = $('[data-js="sg-overview-content"]');
    var $sgPlayButton = $('[data-js="sg-overview-play"]');

    //Lucioball section elements
    var $lucioBallSection = $('[data-js="lucio-ball-section"]');
    var $lucioBallDescription = $('[data-js="lucio-ball-description"]');
    var $lucioBallDescriptionMobile = $('[data-js="lucio-ball-description-mobile"]');
    var $lucioImage = $('[data-js="lucio-image"]');
    var $ballImage = $('[data-js="ball-image"]');

    //Hook into the lightbox so when the user views unlocks the youtube trailer will pause
    var $lightbox = $('.lightbox');
    var $body = $('body');

    //All fade-in elements
    var $scrollElem = determineScrollElem();

    //Microsoft browser check
    var isIEOrEdge = overwatch.util.ie() || /Edge/.test(navigator.userAgent);

    //Distance down the page in pixels
    var viewTop = $scrollElem.scrollTop();

    function sgInit() {
        //Create the summer games video player
        sgPlayer = new YT.Player('sg-player', {
            height: "100%",
            width: "100%",
            videoId: $("#sg-player").data("video-id"),
            playerVars: {rel: 0, modestbranding: 1, autohide: 1, color: "white", playsinline: 1},
            events: {'onStateChange': parallaxVideoStateChange}
        });

        //Throttle and call resize function, and bind to resize event.
        var sgResizeThrottled = window.app.util.debounce(sgResize, 200, false);
        $window.resize(sgResizeThrottled);

        //Pause the video when the user views a lightbox
        $lightbox.on('show', function() {
            if (!isMobile && isVideoPlaying) {
                sgPlayer.pauseVideo();
            }
            isLightboxOpen = true;
        });
        $lightbox.on('hide', function() {
            if (!isMobile && isVideoPlaying) {
                sgPlayer.playVideo();
            }
            isLightboxOpen = false;
        });

        //Bind a click event to the play button.
        $sgPlayButton.on("click", function(e) {
            if (!isMobile) {
                e.preventDefault();
                openVideo();
            }
        });
        //Close video button
        $videoClose.on("click", closeVideo);

        //Add fade-in animation to all the media items
        $(".media-card").each(function() {
            $(this).attr("data-fadein", "true");
        });
        app.Fadein.init();

        //Parallax on scroll
        $window.on("scroll", _.throttle(parallaxSGHeader, 5));
        $window.on("scroll", parallaxLucioBall);

        //Fix scroll jumpyness on IE by capturing the event and preventing a preemptive repaint.
        if (isIEOrEdge) {
            $scrollElem.on("wheel", emulateIEScroll);
        }

        //Initial page resize
        sgResizeThrottled();
    }

    //All desktop and mobile
    function parallaxSGHeader() {
        /*
            NOTE TO FUTURE DEVS:
            Parallax elements should be 'position: fixed' wherever possible.
            Without this, there will be lots of stuttering on IE/Edge and mobile browsers

            These browsers have 2 repaints: 1 after you scroll and another for the JS updates
            Fixed elements, however, do not update during the scroll repaint.
            I couldn't find this answer on google so I'm leaving it here.
        */
        //Get the scroll position of the page
        //Make the minimum value of viewTop 0 so that parallax doesn't happen when iOS
        //users scroll up when at the top of the page
        viewTop = Math.max($scrollElem.scrollTop(), 0);

        //Height of the header section minus 100px so the video pops out sooner.
        var videoPopoutThreshold = $sgOverview.height() - 100;
        //Should the video be popped out?
        isVideoPoppedOut = viewTop > videoPopoutThreshold;

        //If the header section is 200px above the viewport (buffer)
        if (viewTop > $sgOverview.height() + 200) {
            //Hide the parallax elements (they are fixed and will be seen through the footer.)
            $sgOverview.addClass("sg-opacity-none");
            //No need to parallax since nothing is visible
            return;
        } else {
            $sgOverview.removeClass("sg-opacity-none");
        }
        $sgOverviewBackground.css({
            "background-position": "right calc(" + (viewTop/8) + "px - 10vh)"
        });
        $sgOverviewLogo.css({
            "transform": "translateY(" + -viewTop*0.17 + "px)"
        });
        $sgOverviewContent.css({
            "transform": "translateY(" + -viewTop/2.15 + "px"
        })
        //Parallax the header content
        //These values are all basically just guess and check.  Everything in the header is based on the viewTop
        // $(".event-background").css({
        //     "transform": "translateY(" + -viewTop*.5 + "px)"
        // });
        $sgPlayButton.css({
            "transform": "translateY(" + viewTop/4.0 + "px)"
        });
    }

    //Desktop (not microsoft browsers) only
    function parallaxSGVideo() {
        if (!isVideoPoppedOut) {
            $sgIframe.css({"transform": "translateY(" + viewTop/2.0 + "px)"});
        }
    }

    //Desktop only
    function sgPopoutVideo() {
        if (isVideoPoppedOut) {
            $sgIframe.addClass("is-popout");
        } else {
            $sgIframe.removeClass("is-popout");
        }
    }

    function sgResize() {
        //Chache these checks so they don't have to be done elsewhere
        isMobile = !overwatch.util.isSizeAtLeast("md");
        isTablet = !overwatch.util.isSizeAtLeast("lg");

        //Only ever have event listeners firing if its absolutely required.
        //Some functionality is disabled for mobile/IE
        unbindDesktopEventHandlers();
        if (!isMobile) {
            bindDesktopEventHandlers();
        } else {
            //Video should not show on mobile
            if ($sgIframe.is(":visible")) {
                closeVideo();
            }
        }
        //Chache some values needed for the lucio section
        lucioballTextHeight = $lucioBallDescription.outerHeight();
        lucioVals = mathUtil.getRelativeValuesForAnElement($lucioBallSection);
        //Trigger scroll event so things are re-positinoed after resize
        $window.scroll();
    }

    function bindDesktopEventHandlers() {
        $window.on("scroll", sgPopoutVideo);
        $window.on("scroll", parallaxLucioBallText);
        if (!isIEOrEdge) {
            $window.on("scroll", parallaxSGVideo);
        }
    }

    function unbindDesktopEventHandlers() {
        $sgPlayButton.off("click", openVideo);
        $window.off("scroll", parallaxSGVideo);
        $window.off("scroll", sgPopoutVideo);
        $window.off("scroll", parallaxLucioBallText);
    }

    function determineScrollElem() {
        return $(window);
    }

    //This shows and plays the trailer video
    function openVideo() {
        sgPlayer.playVideo();
        $sgIframe.show();
        $videoCloseTop.show();
        $sgOverview.addClass("is-playing");
        $body.addClass("nav-transparent");
        //wait for animation to finish before resizing
        setTimeout(sgResize, 200);
    }

    function closeVideo() {
        $sgIframe.hide();
        $videoCloseTop.hide();
        $sgOverview.removeClass("is-playing");
        sgPlayer.pauseVideo();
        $body.removeClass("nav-transparent");
        //wait for animation to finish before resizing
        setTimeout(sgResize, 200);
    }

    function parallaxVideoStateChange(event) {
        //Restart and hide the video when it ends.
        if (event.data == 0) {
            closeVideo();
            sgPlayer.seekTo(0);
            isVideoPlaying = false;
        } else if (event.data == 1) {
            isVideoPlaying = !isLightboxOpen;
        } else if (event.data == 2) {
            isVideoPlaying = isLightboxOpen;
        }
    }

    function parallaxLucioBall() {
        //Map from one range to another. See the mathUtil object for more details
        var lucioBallTop = mathUtil.mapLerp(viewTop, lucioVals.sourceMin, lucioVals.sourceMax, lucioVals.destMin, lucioVals.destMax/2);
        $lucioImage.css({
            "top": -lucioBallTop - (isTablet && !isMobile ? 0 : 100) + "px"
        });
        //Ball has different size ranges at different breakpoints
        var ballSize;
        if (overwatch.util.isSizeAtLeast("xxl")) {
            ballSize = mathUtil.mapLerp(viewTop, lucioVals.sourceMin, lucioVals.sourceMax, 256, 380); //On desktop, scale the ball from 256 WxH to 380 WxH
        } else {
            ballSize = mathUtil.mapLerp(viewTop, lucioVals.sourceMin, lucioVals.sourceMax, 128, 256); //On tablet, scale the ball from 128 WxH to 256 WxH
        }
        //Move the ball further down the screen to account for the full-width text at this breakpoint
        lucioBallTop += (isTablet) ? lucioballTextHeight*4 : 0;
        $ballImage.css({
            "width": ballSize + "px",
            "height": ballSize + "px",
            "top": lucioBallTop/4 + "px"
        });
    }
    function parallaxLucioBallText() {
        //Parallax the text
        var lucioTextTop = mathUtil.mapLerp(viewTop, lucioVals.sourceMin, lucioVals.sourceMax, 0, 50);
        $lucioBallDescription.css({
            "transform": "translateY(" + lucioTextTop + "px)"
        });
    }

    //Capture and emulate the mousewheel so that the browser will repaint scroll on the
    //same frame as it repaints javascript
    function emulateIEScroll(e) {
        e.preventDefault();
        var windowScrollDelta = -e.originalEvent.deltaY;
        var currentPageOffset = window.pageYOffset;
        $window.scrollTop(currentPageOffset - windowScrollDelta);
    }

    app.sgStart = function() {
        //The youtube API will call this function once it's loaded
        window.onYouTubeIframeAPIReady = function() {
            sgInit();
        }
        app.events.base.setupUnlocks();
    }
}(this, this.app);
